const steps = [
  { num: '01', title: 'Tell us what you need', description: 'Share your IT requirement with our team.' },
  { num: '02', title: 'Get the right solution', description: 'We recommend the right products and technology solution.' },
  { num: '03', title: 'Setup & implementation', description: 'We handle installation, configuration and setup.' },
  { num: '04', title: 'Stay supported', description: 'Get continued maintenance and technical assistance.' },
];

export default function HowItWorks() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-site mx-auto px-4 md:px-6">
        <div className="text-center mb-14 md:mb-20 animate-on-scroll">
          <span className="font-label text-xs uppercase tracking-[0.2em] text-foreground-500">How We Work</span>
          <h2 className="mt-4 font-heading text-[36px] md:text-[48px] font-bold text-foreground-950 tracking-[-0.02em] leading-[1.14]">
            IT support without<br />the complexity.
          </h2>
        </div>

        {/* Desktop: horizontal timeline with animated progress */}
        <div className="hidden md:block animate-on-scroll">
          <div className="relative">
            {/* Base track */}
            <div className="absolute top-[28px] left-[8%] right-[8%] h-px bg-background-200"></div>
            {/* Animated fill track */}
            <div className="absolute top-[28px] left-[8%] h-px bg-primary-500 animate-on-scroll is-visible" style={{ width: '0%', transition: 'width 1.2s ease-out 0.3s' }} id="progress-line">
              <style>{`
                #progress-line.is-visible { width: 84%; }
              `}</style>
            </div>
            <div className="grid grid-cols-4 gap-6 relative">
              {steps.map((step, i) => (
                <div key={step.num} className="text-center">
                  <div className="relative z-10 mx-auto w-14 h-14 rounded-xl flex items-center justify-center font-heading text-lg font-bold text-background-50 mb-5 transition-all duration-500" style={{ backgroundColor: '#0167F8', boxShadow: '0 4px 20px rgba(1,103,248,0.25)' }}>
                    {i + 1}
                  </div>
                  <h4 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-2">{step.title}</h4>
                  <p className="text-sm text-foreground-600 leading-relaxed">{step.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Mobile: vertical timeline */}
        <div className="md:hidden animate-on-scroll">
          <div className="relative pl-10">
            <div className="absolute left-[23px] top-2 bottom-2 w-px bg-background-200"></div>
            <div className="absolute left-[23px] top-2 w-px bg-primary-500 animate-on-scroll is-visible" style={{ height: '0%', transition: 'height 1s ease-out 0.3s' }} id="mobile-progress-line">
              <style>{`
                #mobile-progress-line.is-visible { height: 90%; }
              `}</style>
            </div>
            {steps.map((step, i) => (
              <div key={step.num} className={`relative pb-10 ${i === steps.length - 1 ? 'pb-0' : ''}`}>
                <div className="absolute left-[-34px] top-0 w-12 h-12 rounded-xl flex items-center justify-center font-heading text-base font-bold text-background-50 z-10" style={{ backgroundColor: '#0167F8', boxShadow: '0 4px 20px rgba(1,103,248,0.25)' }}>
                  {i + 1}
                </div>
                <h4 className="font-heading text-base font-bold text-foreground-950 mb-1">{step.title}</h4>
                <p className="text-sm text-foreground-600 leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}